import * as React from 'react';
import { LinkButton, useDeviceType } from '@cian/ui-kit';
import { pluralize } from '@cian/newbuilding-utils';
import { trackListingLinkClick } from './tracking';

interface IProjectsListButtonProps {
  url: string;
  count: number;
}

export const ProjectsListButton = ({ url, count }: IProjectsListButtonProps) => {
  const deviceType = useDeviceType();

  const title = React.useMemo(() => {
    if (deviceType === 'phone') {
      return `Все жилые комплексы (${count})`;
    }

    return `Показать все ${pluralize(count, ['объект', 'объекта', 'объектов'])}`;
  }, [deviceType, count]);

  const size = React.useMemo(() => {
    return deviceType === 'phone' ? 'M' : 'L';
  }, [deviceType]);

  const handleClick = React.useCallback(() => {
    setTimeout(trackListingLinkClick, 0);
  }, []);

  return (
    <LinkButton href={url} theme="fill_secondary" fullWidth size={size} target="_blank" onClick={handleClick}>
      {title}
    </LinkButton>
  );
};
